import React from 'react'
import { Text } from 'components/ds'
type Props = {
  caption: string
  htmlFor?: string
}

/**
 * Label component for form fields in login forms
 * Styled label element with consistent typography and accessibility support
 * @param caption - Label text to display
 * @param htmlFor - ID of the associated form control
 */
const Label = ({ caption, htmlFor }: Props): React.ReactNode => (
  <Text as="label" size="1" color="gray" htmlFor={htmlFor}>
    {caption}
  </Text>
)

export default Label
